import Text from '@components/Text';
import colors from '@constants/colors';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

function GiftMessage() {
    const { t } = useTranslation('gift');
    return (
        <div className={styles.container}>
            <Text color={colors.gray6}>
                {t('giftReceived.messageExample')}
            </Text>
        </div>
    );
}

export default GiftMessage;
